import "../stylesheets/Page.css";

import React from "react";
import { Alert } from "react-bootstrap";

import Submitter from "../classes/Submitter";
import Util from "../classes/Util";

import PageManager from "../manager/PageManager";
import ScreenManager from "../manager/ScreenManager";
import BlobStorageManager from "../manager/BlobManager";

import Header from "./Header";

import Button from "react-bootstrap/Button";

/** @typedef {import("../classes/PageTemplate").default} PageTemplate */

const pageManager = PageManager.instance;
const screenManager = ScreenManager.instance;
const blobManager = BlobStorageManager.instance;

/**
 * Displays an uploaded forum entry. The prop "template" will be used as source.
 * If this is not given, the props "id" and "topic" will be used to fetch
 * the entry from the cosmosDB.
 */
export default class Page extends React.PureComponent {

    // either id and topic or template directly. The section is the section from the page before
    /** @type {{ id: string, template: PageTemplate, section: string }} */
    props;

    constructor(props) {
        super(props);

        this.state = {
            PageTemplate: this.props.template,
            html: "",
            /** @type {{ filename: string, url: string, contentType: string, contentLength: number, date: Date, exists: boolean } []} */
            files: null
        }
    }

    async componentDidMount() {
        // get page from server if none was passed
        const template = this.state.PageTemplate || await pageManager.getPage( this.props.id, this.props.topic );
        const files = await Promise.all( template.fileUrls.map( url => blobManager.getBlobProperties( blobManager.getAnonymousBlobUrl(url) ) ) );

        // join sections to one html page and set files
        this.setState({
            PageTemplate: template,
            html: pageManager.pageTemplateToHtml( template ),
            files: files.filter( f => f.exists )
        });
    }

    render() {

        const tmpl = this.state.PageTemplate;
        const loading = tmpl === undefined;
        
        return (
            <div className="flexContainer secondaryColorBackground" >

                <Header title={loading ? "lade..." : tmpl.title}>
                    <Button variant="dark" onClick={() => screenManager.changeScreen("EditEntry", { section: this.props.section, template: tmpl })} >bearbeiten</Button>
                </Header>

                { loading ? <div className="centeredItems flexContainer"><div className="spinner-border" role="status" /></div> :
                    
                    <>
                        <div id="page-body" className="markdown-body" dangerouslySetInnerHTML={{ __html: this.state.html }} />
                        <footer id="page-footer" >
                        <div className="page-footer-row" >
                                <span className="rowContainer" ><strong>{"Anhang:"}&nbsp;</strong>{ this.state.files == null ? "lade..." : this.state.files.length === 0 ? "keine Dateien vorhanden" :
                                    this.state.files.map( (f, i) => (
                                        <span key={"file-"+i} >
                                            {i===0?"":", "}
                                            <Alert.Link variant="light" href={f.url} >{`${f.filename} (${BlobStorageManager.humanFileSize(f.contentLength)})`}</Alert.Link>
                                        </span>
                                    ))
                                }</span>
                            </div>
                            <div className="page-footer-row" >
                                <div><strong>{"Kategorien: "}</strong>{tmpl.tags.map( tag => tag.name ).join(", ")}</div>
                            </div>
                            {/*<div className="page-footer-row" >
                                <div><strong>{"Betroffene Gruppen: "}</strong>{tmpl.audiences.map( tag => tag.name ).join(", ")}</div>
                            </div>*/}
                            <div className="page-footer-row" >
                                <div><strong>{"Betroffenes Bundesland: "}</strong>{Util.getRegionNameFromCode(tmpl.region)}</div>
                            </div>
                            <div className="page-footer-row" >
                                <div><strong>{"Ein Beitrag von: "}</strong>{tmpl.submitter ? tmpl.submitter.toString() : Submitter.ANONYMUS}</div>
                                <div>{"Zuletzt geändert am " + Util.timestampToDateString( tmpl._ts )}</div>
                            </div>
                        </footer>
                    </>

                }

            </div>
        );

    }

}